
'use strict';
{
    var app = angular.module('tf.legal', [])

        .controller('legalCtrl', ['$scope', '$uibModalInstance', 'userConfig', '$http', '$window', function legalController($scope, $uibModalInstance, userConfig, $http, $window) {

            $scope.oneAtATime = true;

            $scope.intro = {
                open: true
            };

            $scope.submit = function() {
                $uibModalInstance.close('accept');
            };

        }]);
}